var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layer',[_c('v-group',_vm._l((_vm.ship.middle),function(section){return _c('v-image',{key:section.id,attrs:{"config":_vm.getSectionConfig(section)},on:{"contextmenu":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleRightClick(section, $event)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }